/**
 * @file 落地页请求方法
 * @author FengGuang(fengguang01@baidu.com)
 */
import request from 'superagent';
import baseRequest from '../baseApi';


// 获取落地页详情
export interface IGetPaddleParam {
    requestUrl?: string;
}

export const fetchGetPaddleInfo = (params: IGetPaddleParam | string): Promise<request.Response> =>
    baseRequest(
        request.get('/platform/page/data')
            .query(params)
            .query(window.location.search.slice(1))
    );
